import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { ConfigService } from 'src/providers/config/config.service';
import { LoadingService } from 'src/providers/loading/loading.service';
import { SharedDataService } from 'src/providers/shared-data/shared-data.service';
import { SelectZonesPage } from '../select-zones/select-zones.page';
import { SelectCountryPage } from '../select-country/select-country.page';
import { AppEventsService } from 'src/providers/app-events/app-events.service';
import { GoogleMapComponent } from 'src/components/google-maps/google-maps.component';



interface Marker {
  position: {
    lat: number,
    lng: number,
  };
  title: string;
}

@Component({
  selector: 'app-edit-address',
  templateUrl: './edit-address.page.html',
  styleUrls: ['./edit-address.page.scss'],
})
export class EditAddressPage implements OnInit {
  @ViewChild(GoogleMapComponent, { static: false }) mapComp: GoogleMapComponent;
  shippingData: { [k: string]: any } = {};
  data;
  type = 'update';
  map = null;
  verGEO = true;
  public myLatLng;
  public Mark;

  constructor(
    public appEventsService: AppEventsService,
    public config: ConfigService,
    public modalCtrl: ModalController,
    public loading: LoadingService,
    public shared: SharedDataService,
    public navParams: NavParams
  ) {

    this.data = navParams.get('data');
    this.type = navParams.get('type');

    if (this.type != 'add') {
      this.shippingData.address_book_id = this.data.address_id;
      this.shippingData.entry_firstname = this.data.firstname;
      this.shippingData.entry_lastname = this.data.lastname;
      this.shippingData.entry_street_address = this.data.street;
      this.shippingData.entry_country_name = this.data.country_name;
      this.shippingData.entry_zone = this.data.zone_name;
      this.shippingData.entry_postcode = this.data.postcode;
      this.shippingData.entry_country_id = this.data.countries_id;
      this.shippingData.entry_address_id = this.data.address_id;
      this.shippingData.entry_city = this.data.city;
      this.shippingData.entry_zone_id = this.data.zone_id;
      this.shippingData.entry_state = this.data.state;
      this.shippingData.entry_suburb = this.data.suburb;
      this.shippingData.entry_latitude = this.data.latitude;
      this.shippingData.entry_longitude = this.data.longitude;
      if (this.data.zone_name == null) this.shippingData.entry_zone = "other"
    } else {
      this.shippingData.entry_firstname = this.data.customers_firstname;
      this.shippingData.entry_lastname = this.data.customers_lastname;
      this.shippingData.entry_postcode = '';
      this.shippingData.entry_latitude = '';
      this.shippingData.entry_longitude = '';
      this.shippingData.entry_country_id = 166;
      this.shippingData.entry_country_name = 'Paraguay';
      this.shippingData.entry_zone_id = 1;
      this.shippingData.entry_city = 'Asuncion';
    }

  }

  async selectCountryPage() {
    let modal = await this.modalCtrl.create({
      component: SelectCountryPage,
      componentProps: { page: 'editShipping' }
    });
    modal.onDidDismiss().then(() => {
      this.updateCountryZone();
    })
    return await modal.present();
  }
  async selectZonePage() {

    let modal = await this.modalCtrl.create({
      component: SelectZonesPage,
      componentProps: { page: 'editShipping', id: this.shippingData.entry_country_id }
    });
    modal.onDidDismiss().then(() => {
      this.updateCountryZone();
    })
    return await modal.present();
  }
  //close modal
  dismiss() {
    this.modalCtrl.dismiss();
  }

  //============================================================================================  
  //adding shipping address of the user
  addShippingAddress = function (form) {
    this.loading.show();


    /* Grabamos geo */
    let position = this.mapComp.getPosition();
    this.shippingData.entry_latitude = position.latitud.toString();
    this.shippingData.entry_longitude = position.longitud.toString();

    this.shippingData.customers_id = this.shared.customerData.customers_id;
    var dat = this.shippingData;
    //dat.entry_state = dat.delivery_zone;
    // dat.entry_zone = dat.delivery_zone;
    dat.is_default = 0;

    this.config.post_Http('addshippingaddress', dat)
      .subscribe(
        (data) => { // Success        
          this.loading.hide();
          this.dismiss();
          this.shared.toast(data['resultado'].message);
        },
        (error) => {
          this.loading.hide();
          console.log(error);
        });
  };
  //============================================================================================  
  //updating shipping address of the user
  updateShippingAddress = function (form, id) {
    this.loading.show();

    /* Grabamos geo */
    let position = this.mapComp.getPosition();
    this.shippingData.entry_latitude = position.latitud.toString();
    this.shippingData.entry_longitude = position.longitud.toString();

    this.shippingData.customers_id = this.shared.customerData.customers_id;
    var dat = this.shippingData;
    //dat.entry_state = dat.delivery_zone;
    //dat.entry_zone = dat.delivery_zone;
    dat.is_default = 0;


    this.config.post_Http('updateshippingaddress', dat)
      .subscribe(
        (data) => { // Success        
          this.loading.hide();
          this.dismiss();
          this.shared.toast(data['resultado'].message);
        },
        (error) => {
          this.loading.hide();
          console.log(error);
        });
  };

  updateCountryZone() {
    if (this.shared.tempdata.entry_country_id != undefined) {
      this.shippingData.entry_country_id = this.shared.tempdata.entry_country_id;
      this.shippingData.entry_country_name = this.shared.tempdata.entry_country_name;
      this.shippingData.entry_country_code = this.shared.tempdata.entry_country_code;
      this.shippingData.entry_zone = this.shared.tempdata.entry_zone;
    }
    if (this.shared.tempdata.entry_zone != undefined) {
      this.shippingData.entry_zone = this.shared.tempdata.entry_zone;
      this.shippingData.entry_zone_id = this.shared.tempdata.entry_zone_id;
    }
  }

  ngOnInit() {

  }


  geolocalizacion() {

    if (this.verGEO) {
      console.log(this.shippingData.entry_latitude, this.shippingData.entry_longitude);
      this.verGEO = false;
      if (this.shippingData.entry_latitude != '' && this.shippingData.entry_longitude != '') {
        let position = this.mapComp.getPosition();
        console.log(position);

        this.mapComp.addMarker_actual(position.latitud, position.longitud, 'Ubicacion actual...');
        this.mapComp.addMarker_drag(parseFloat(this.shippingData.entry_latitude), parseFloat(this.shippingData.entry_longitude), this.shippingData.entry_firstname + ' ' + this.shippingData.entry_lastname);
        this.mapComp.autoCenter();
      } else {
        let position = this.mapComp.getPosition();
        console.log(position);
        this.mapComp.addMarker_drag(position.latitud, position.longitud, this.shippingData.entry_firstname + ' ' + this.shippingData.entry_lastname);
      }
    }
  }



}
